<template>
  <el-dialog title="Send Request" :width="dialogWidth" :visible.sync="visible" :close-on-click-modal="false">
    <div v-loading="form_loading">
      <div class="form">
        <div class="div">
          Name*
          <el-input class="margin-top-switch" placeholder="Name" v-model="account_obj.name"/>
        </div>
        <div class="div">
          <div>
            <el-checkbox v-model="is_need_email" disabled>E-Mail</el-checkbox>
          </div>
          <el-input v-if="is_need_email" class="margin-top-switch" placeholder="E-Mail" v-model="account_obj.email"/>
        </div>
        <div class="div">
          <div>
            <el-checkbox v-model="is_need_sms">Phone Number</el-checkbox>
          </div>
          <el-input v-if="is_need_sms" class="margin-top-switch" placeholder="Phone Number"
          v-model="phone_show" @change="change_phone">
            <template slot="prepend">
              <el-select v-model="countryCity" style="width:75px;" @change="change_phone">
                <el-option label="+1" value="+1"></el-option>
                <!-- <el-option label="+33" value="+33"></el-option> -->
                <el-option label="+44" value="+44"></el-option>
                <!-- <el-option label="+49" value="+49"></el-option>
                <el-option label="+55" value="+55"></el-option>
                <el-option label="+61" value="+61"></el-option>
                <el-option label="+81" value="+81"></el-option>
                <el-option label="+91" value="+91"></el-option> -->
              </el-select>
            </template>
          </el-input>
        </div>

      </div>
      <div class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button type="primary" size="small" @click="save_send" style="background-color: #5856D6;border-color:#5856D6;">Send</el-button>
      </div>
    </div>
  </el-dialog>

</template>

<script>
import Vue from 'vue';
import { getActionApi, postActionApi } from '@/network/manageApi';
export default {
  name: 'Request',
  components: {},
  data() {
    return {
      dialogWidth:'800px',
      visible: false,
      account_obj: {},
      form_loading: false,
      is_need_email: false,
      is_need_sms:false,
      countryCity: "+1",
      phone_show: ""
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    get_phone_require_length(type) {
      if(type == "+55") {
        return 11;
      } else if(type == "+33") {
        return 9;
      } else if(type == "+49") {
        return 11;
      } else if(type == "+81") {
        return 11;
      } else if(type == "+61") {
        return 10;
      } else if(type == "+91") {
        return 10;
      } else if(type == "+44") {
        return 9;
      } else if(type == "+1") {
        return 10;
      } else {
        return 0
      }
    },
    format_phone(localNumber, countryCode) {
      const phoneFormats = {
        "+1": "(XXX) XXX-XXXX", // USA, Canada
        "+44": "07XXX XXXXXX",   // UK Local Mobile
        "+91": "XXXXX-XXXXX",   // India
        "+61": "XXXX XXX XXX",  // Australia
        "+81": "XXX-XXXX-XXXX", // Japan
        "+49": "XXXX XXXXXXX",  // Germany
        "+33": "X XX XX XX XX",  // France
        "+55": "(XX) XXXXX-XXXX" // Brazil
      };
      let format = phoneFormats[countryCode] || "XXXX-XXXX-XXXX";
      let digits = localNumber.replace(/\D/g, "");
      let formattedNumber = "";
      let digitIndex = 0;
      for (let char of format) {
          if (char === "X" && digitIndex < digits.length) {
              formattedNumber += digits[digitIndex];
              digitIndex++;
          } else {
              formattedNumber += char;
          }
      }
      return formattedNumber;
    },
    change_phone() {
      if(!this.phone_show) {
        return;
      }
      let phone = this.phone_show.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
      if(this.countryCity == "+44") {
        if(phone.length == 11 && phone.indexOf("07") == 0) {
          phone = phone.substring(2);
        } else if(phone.length == 10 && phone.indexOf("7") == 0) {
          phone = phone.substring(1);
        }
      }
      if(this.get_phone_require_length(this.countryCity) != phone.length) {
        this.$message({
          message: 'Please enter the correct phone number.',
          type: 'warning'
        });
        return;
      }
      this.phone_show = this.format_phone(phone, this.countryCity)
    },
    init() {
      this.visible = true
      this.account_obj = {}
      this.phone_show = ""
      this.is_need_email = false
      this.is_need_sms = false
      getActionApi('/user-management/my-information').then(res => {
        this.countryCity = "+" + res.data.twilio.twilio_number.country_code
      })
    },
    save_send() {
      if(!this.account_obj.name) {
        this.$message({
          message: 'Please enter your name.',
          type: 'warning'
        });
        return;
      }
      let param = {name: this.account_obj.name}
      if(this.is_need_email) {
        if(!this.account_obj.email) {
          this.$message({
            message: 'Please enter your e-mail.',
            type: 'warning'
          });
          return;
        }
        if(!this.validateEmail(this.account_obj.email)) {
          this.$message({
            message: 'Please enter the correct e-mail.',
            type: 'warning'
          });
          return;
        }
        param.email = this.account_obj.email
      }
      if(this.is_need_sms) {
        if(!this.phone_show) {
          this.$message({
            message: 'Please enter your phone number.',
            type: 'warning'
          });
          return;
        }
        let phone = this.phone_show.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
        if(this.countryCity == "+44") {
          if(phone.length == 11 && phone.indexOf("07") == 0) {
            phone = phone.substring(2);
          } else if(phone.length == 10 && phone.indexOf("7") == 0) {
            phone = phone.substring(1);
          }
        }
        if(this.get_phone_require_length(this.countryCity) != phone.length) {
          this.$message({
            message: 'Please enter the correct phone number.',
            type: 'warning'
          });
          return;
        }
        param.phone_number = this.get_phone_submit_format(this.countryCity, this.phone_show)
      }
      this.form_loading = true
      postActionApi("/review/business-promoter", param).then((res) => {
        if(res.code == 201 || res.code == 200) {
          this.$emit('ok')
          this.visible = false
        }
      }).catch((err) => {
        this.$message.error({message: err.response.data.details.data.message});
      }).finally((res) => {
        this.form_loading = false
      })
    },
    get_phone_submit_format(countryCity, phone_show) {
      let phone = phone_show.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
      if(countryCity == "+1") {
        return countryCity + "-" + phone_show.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "-")
      } else if(countryCity == "+44") {
        return countryCity + "-" + phone_show.replaceAll(" ", "-")
      } else {
        return null;
      }
    },
    validateEmail(email) {
        var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    },
    validatePhoneNumber(phoneNumber) {
      var regex = /^(\+\d+-)?\d+-\d+-\d+$/;
      return regex.test(phoneNumber);
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 800 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .div{display: flex;flex-direction: column;color:#A0ABC0;font-weight: bold;padding-bottom:20px;}
  .form .div input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .form .div select{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;box-sizing: border-box;}
  .headImage{display: flex;width: 76px;margin-top:15px;}
  .headImage .edit{display: none;padding-bottom:0;width: 76px;height: 76px;position: absolute;justify-content: center;align-items: center;background-color: rgba(0, 0, 0, 0.5);border-radius: 4px;}
  .headImage .edit span{background-color: rgba(255, 255, 255, 0.36);margin-left:0;padding:4px 10px;border-radius:4px;font-weight: bold;color:#ffffff;cursor: pointer;}
  .headImage:hover .edit{display: flex;}
  .headImage img{width: 76px;height: 76px;border-radius: 4px;}
  .default_upload {width: 76px;height: 76px;border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;display: flex;align-items: center;justify-content: center;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .font-size-16 {font-size: 16px;}
  .margin-top-switch {margin-top: 10px;}
</style>
